import React, { useEffect } from 'react';
import Header from '../Header.js';
import Sidebar from '../Sidebar.js';
import { requestAppPermissions } from '../../../utils/devicePermissions.js';

function DashboardLayout({ children, fullWidth = false, fillViewport = false, hideSidebar = false }) {
  useEffect(() => {
    requestAppPermissions();
  }, []);
  return (
    <div className="h-screen flex flex-col bg-gray-50/50 overflow-hidden">
      <Header />
      <div className="flex flex-1 min-h-0 overflow-hidden">
        {!hideSidebar && <Sidebar />}
        <main
          className={`flex-1 min-w-0 min-h-0 overflow-x-hidden ${
            fillViewport ? 'p-2 sm:p-3 md:p-4 overflow-hidden flex flex-col' : 'p-3 sm:p-4 md:p-6 lg:p-8 overflow-y-auto'
          }`}
        >
          <div className={`${fullWidth ? 'w-full' : 'max-w-[1600px] mx-auto'} ${fillViewport ? 'flex-1 min-h-0 flex flex-col min-w-0' : ''}`}>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}

export default DashboardLayout;
